<template>
  <div class="vip2-list">
    <div v-if="activeMemberships.length" class="vip-summary"><span>当前有效会员 {{ activeMemberships.length }} 项</span><strong>可用点数 {{ availableMembershipPoints }}</strong></div>
    <article v-for="(item, index) in displayMemberships" :key="item.id || index" class="vip2-card"
      :class="{ inactive: isVipInactive(item) }">
      <div class="vip2-top">
        <div class="vip2-identity">
          <div class="vip2-icon"><app-icon  class="app-icon" name="workspace_premium"></app-icon></div>
          <div>
            <div class="vip2-name">{{ item.name || '会员权益' }}</div>
            <div class="vip2-status"><span></span>{{ isVipInactive(item) ? '权益已失效' : '权益使用中' }}</div>
          </div>
        </div>
        <span class="vip2-tag">{{ isVipInactive(item) ? '已失效' : '使用中' }}</span>
      </div>

      <div class="vip2-expiry">
        <app-icon  class="app-icon" name="event"></app-icon>
        <span>有效期至</span>
        <strong>{{ formatTime(item.end_at) }}</strong>
      </div>

      <div class="vip2-metrics">
        <div class="metric">
          <span>剩余点数</span>
          <strong>{{ item.remaining_points || 0 }}</strong>
        </div>
        <div class="metric">
          <span>已使用点数</span>
          <strong>{{ item.used_points || 0 }}</strong>
        </div>
      </div>
    </article>

    <div v-if="loading" class="vip2-loading">
      <i class="el-icon-loading"></i>
      <span>正在加载会员权益...</span>
    </div>

    <div v-else-if="requestError" class="vip2-empty">
      <div class="empty-icon"><app-icon  class="app-icon" name="cloud_off"></app-icon></div>
      <strong>会员权益加载失败</strong>
      <el-button size="mini" plain @click="get_vip_list">重新加载</el-button>
    </div>

    <div v-else-if="list.length === 0" class="vip2-empty">
      <div class="empty-icon"><app-icon  class="app-icon" name="card_membership"></app-icon></div>
      <strong>暂未开通会员</strong>
      <span>开通会员后可在这里查看权益详情</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'User2UserVip',
  data() {
    return {
      list: [],
      page: 1,
      loading: false,
      requestError: false
    }
  },
  computed: {
    availableMembershipPoints() { return this.activeMemberships.reduce((total, item) => total + Number(item.remaining_points || 0), 0) },
    activeMemberships() { return this.list.filter(item => !this.isVipInactive(item)) },
    displayMemberships() { return this.activeMemberships.concat(this.list.filter(item => this.isVipInactive(item))) }
  },
  methods: {
    get_vip_list() {
      this.loading = true
      this.requestError = false
      this.$ajax.get(`api/v1/users/memberships?page=${this.page}&page_size=20`).then(res => {
        const body = res.data || {}
        if (body.status !== 200) throw new Error(body.msg || '会员权益加载失败')
        this.list = (body.data && body.data.items) || []
      }).catch(() => {
        this.requestError = true
      }).finally(() => {
        this.loading = false
      })
    },
    formatTime(timestamp) {
      const value = Number(timestamp || 0)
      if (!value) return '—'
      const date = new Date(value * 1000)
      const pad = number => String(number).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
    },
    isVipInactive(item) {
      return !item.is_active
    }
  }
}
</script>

<style scoped>
.vip2-list { display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 14px; }
.vip2-card { position: relative; padding: 14px 16px; border: 1px solid #e2e8f0; border-radius: 12px; background: linear-gradient(145deg, #fff 0%, #f8fafc 100%); overflow: hidden; box-sizing: border-box; transition: border-color .2s, box-shadow .2s, transform .2s; }
.vip2-card::after { position: absolute; top: -45px; right: -45px; width: 110px; height: 110px; border-radius: 50%; background: rgba(26,115,232,.06); content: ''; }
.vip2-card:hover { border-color: #bfdbfe; box-shadow: 0 10px 28px rgba(15,23,42,.07); transform: translateY(-1px); }
.vip2-card.inactive { border-style: dashed; border-color: #d8dee7; background: #f8fafc; box-shadow: none; }
.vip2-card.inactive:hover { border-color: #cbd5e1; box-shadow: none; transform: none; }
.vip2-card.inactive::after { display: none; }
.vip2-top { position: relative; z-index: 1; display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; }
.vip2-identity { display: flex; align-items: center; gap: 12px; min-width: 0; }
.vip2-icon { display: flex; align-items: center; justify-content: center; flex-shrink: 0; width: 36px; height: 36px; border-radius: 9px; background: #1e293b; color: #fff; }
.vip2-icon span { font-size: 20px; }
.vip2-name { color: #0f172a; font-size: 15px; font-weight: 650; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.vip2-status { display: flex; align-items: center; gap: 5px; margin-top: 4px; color: #64748b; font-size: 11px; }
.vip2-status span { width: 6px; height: 6px; border-radius: 50%; background: #22c55e; box-shadow: 0 0 0 3px #dcfce7; }
.inactive .vip2-icon { background: #cbd5e1; color: #64748b; }
.inactive .vip2-status { color: #94a3b8; }
.inactive .vip2-status span { background: #94a3b8; box-shadow: 0 0 0 3px #e2e8f0; }
.inactive .vip2-tag { border-color: #e2e8f0; background: #f1f5f9; color: #94a3b8; }
.vip2-tag { flex-shrink: 0; padding: 4px 9px; border: 1px solid #dbeafe; border-radius: 999px; background: #eff6ff; color: #2563eb; font-size: 10px; font-weight: 600; }
.vip2-expiry { position: relative; z-index: 1; display: flex; align-items: center; gap: 6px; margin: 12px 0 10px; padding: 7px 0; border-top: 1px solid #e8edf3; border-bottom: 1px solid #e8edf3; color: #94a3b8; font-size: 11px; }
.vip2-expiry .app-icon { font-size: 16px; }
.vip2-expiry strong { margin-left: auto; color: #475569; font-size: 12px; font-weight: 500; }
.vip2-metrics { position: relative; z-index: 1; display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
.metric { display: flex; flex-direction: column; gap: 4px; padding: 7px 10px; border-radius: 8px; background: #fff; box-shadow: inset 0 0 0 1px #edf1f5; }
.metric span { color: #94a3b8; font-size: 10px; }
.metric strong { color: #0f172a; font-size: 16px; font-weight: 600; line-height: 1; }
.inactive .metric { background: #f1f5f9; box-shadow: inset 0 0 0 1px #e2e8f0; }
.inactive .metric strong, .inactive .vip2-name, .inactive .vip2-expiry strong { color: #94a3b8; }
.vip2-empty { grid-column: 1 / -1; display: flex; align-items: center; flex-direction: column; padding: 34px 20px; color: #94a3b8; text-align: center; }
.vip2-loading { grid-column: 1 / -1; display: flex; align-items: center; justify-content: center; gap: 8px; min-height: 128px; color: #64748b; font-size: 13px; }
.vip2-loading i { color: #2563eb; font-size: 20px; }
.empty-icon { display: flex; padding: 11px; margin-bottom: 10px; border-radius: 12px; background: #f1f5f9; color: #64748b; }
.vip2-empty strong { margin-bottom: 5px; color: #475569; font-size: 14px; }
.vip2-empty > span { font-size: 11px; }
.vip2-empty .el-button { margin-top: 10px; }
@media (max-width: 600px) { .vip2-list { grid-template-columns: 1fr; } }

.vip-summary { grid-column:1/-1; display:flex; justify-content:space-between; gap:12px; flex-wrap:wrap; padding:14px; background:#eff6ff; border:1px solid #dbeafe; border-radius:12px; color:#2563eb; font-size:13px; }
.vip-summary strong { font-size:15px; }
</style>



// WEBPACK FOOTER //
// src/components/User2/UserVip.vue